import { InputSearch } from '../../../../components/InputSearch';
import Button from '../../../../components/Button/Button';
import { useParams, useRouteMatch } from 'react-router-dom';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSetFilters } from '../../../../hooks/useSetFilters';

export const SearchBar = () => {
    const setFilters = useSetFilters();
    const { t } = useTranslation();

    const { url } = useRouteMatch();
    const cn = classNames;

    const isArchive = url === '/chain/stores/archive';

    const onChangeSearchQuery = (e) => {
        setFilters({ search: e.target.value });
    };

    return (
        <div className="mt-4 lg:mt-0 lg:ml-auto flex flex-col-reverse sm:flex-row sm:justify-between gap-4">
            <InputSearch onChange={onChangeSearchQuery} />
            <div>
                <Button type="link" to="/chain/stores" color={cn({ 'bg-gray-300': isArchive })} className="whitespace-nowrap h-9 inline-flex items-center rounded-r-none border border-transparent px-4 py-3 text-sm font-bold">
                    {t('Active')}
                </Button>
                <Button
                    type="link"
                    to="/chain/stores/archive"
                    color={cn({ 'bg-gray-300': !isArchive })}
                    className="whitespace-nowrap h-9 inline-flex items-center rounded-l-none border border-transparent px-4 py-3 text-sm font-bold"
                >
                    {t('Archived')}
                </Button>
            </div>
        </div>
    );
};
